export default class ProfileSubscription {
    constructor() {
        this.LANGUAGE = '/' + document.documentElement.lang;
        this.changeOptionsURL = this.LANGUAGE + '/profile/subscription/options';

        this.changeSubsOptions()
    }

    changeSubsOptions() {
        const self = this;
        $('.subscription_list .emails_wrap input[type="checkbox"]').on('change', function () {
            let name = $(this).attr('name'),
                value = $(this).prop('checked') ? 1 : 0;
            self._POST(self.changeOptionsURL, {name: name, value: value}, self.resultChange);
        });
    }

    //TODO: maybe will need show info window
    resultChange(res) {
        //console.log(res);
    }

    /**
     *
     * @param url
     * @param data
     * @param callback
     * @private
     */
    _POST(url, data, callback) {
        let formData = new FormData();

        if(data) {
            for (let property in data) {
                formData.append(property, data[property]);
            }
        }

        $.ajax({
            type: "POST",
            url: url,
            processData: false,
            contentType: false,
            data: formData
        }).done(function (res) {
            callback(res);
        });
    }
}
